<template>
    <div>
        <custom-dialog width="445px" title="拒绝订单" v-if="visibleObj.refuseDialog" :visible="visibleObj.refuseDialog"
            @close="dialogVisible('refuseDialog')" @save="comfirm">
            <div slot="content">
                <el-input type="textarea" placeholder="请输入拒接原因" :maxlength="200" :show-word-limit="true"
                    v-model="refuseReason">
                </el-input>
            </div>
        </custom-dialog>
    </div>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { prescriptionDTO } from '@/DTO/index'
export default {
    // 定义引入的组件
    components: { CustomDialog },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            refuseReason: '',//拒接原因
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
        * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 确认
         */
        async comfirm() {
            let params = { orderId: this.dialogObj.orderId, remark: this.refuseReason }
            let { code, data } = await prescriptionDTO.examineContinueNoPass(params)
            if (code == 200) {
                this.$emit('updateData')
            }
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.el-textarea__inner {
    height: 156px;
}
</style>